// extracted by mini-css-extract-plugin
module.exports = {"root":"PillButton_root__DQhW6","active":"PillButton_active__abPV7","inactive":"PillButton_inactive__MB4r2"};